import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

export const orgByDefaultStateQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "org-by-default"],
  host: "cap-srv",
  method: "GET",
  path: "oasis/users/:userId/org-by-default",
  responseSchema: z.object({ isOrgByDefault: z.boolean() }),
});

export const orgByDefaultMigrationViewQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "org-by-default", "migration-view"],
  host: "cap-srv",
  method: "GET",
  path: "oasis/users/:userId/org-by-default/view",
  responseSchema: z.object({
    isOrgByDefault: z.boolean(),
    orgs: z.array(
      z.object({
        orgId: z.string(),
        orgName: z.string(),
        role: z.enum(["admin", "member"]),
        createdAt: z.string(),
        planTier: z.string(),
        store: z.enum(["stripe", "apple", "none", "unknown"]),
      })
    ),
  }),
});
